module.exports = __webpack_public_path__ + "static/media/tip.a8ea3357.mp3";